// extracted by mini-css-extract-plugin
export default {"InputSpace":"inputsSpace_InputSpace__Wbqlc"};